import {HttpErrorResponse} from '@angular/common/http';

/**
 * True when the failure is a cancelled/aborted HTTP request rather than a
 * transport or server outage. Angular's XHR backend often tears down without
 * emitting, but fetch / AbortError / abort ProgressEvents can still surface
 * as status 0 — those must not open the blocking SystemState overlay.
 */
export function isHttpRequestCancellation(error: HttpErrorResponse): boolean {
    if (error.status !== 0) {
        return false;
    }

    const body = error.error as unknown;
    if (typeof DOMException !== 'undefined' && body instanceof DOMException) {
        return body.name === 'AbortError';
    }
    if (body && typeof body === 'object' && 'name' in body) {
        return (body as {name?: string}).name === 'AbortError';
    }
    if (typeof ProgressEvent !== 'undefined' && body instanceof ProgressEvent) {
        return body.type === 'abort';
    }
    return false;
}
